import { Injectable } from '@angular/core';
import { ILoginService, LoginDto, TokenDto } from '@api/auth/interfaces';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {Observable} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AuthRestService implements ILoginService {

	constructor(private httpClient: HttpClient) { }

	login$(data: LoginDto): Observable<TokenDto> {
		const url = `${environment.serverEndpoint}/api/auth/login`;
		return this.httpClient.post<TokenDto>(url, data)
	}

	async login(data: LoginDto): Promise<TokenDto> {
		const url = `${environment.serverEndpoint}/api/auth/login`;
		const response = await this.httpClient.post<TokenDto>(url, data).toPromise();
		return response;
	}

	currentAccount$(): Observable<any> {
		return this.httpClient.get(`${environment.serverEndpoint}/api/user`)
	}
}
